module.exports = __webpack_public_path__ + "static/media/HB_vegsoup_forweb_new_edited.0fe0087a.jpg";